import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 64vh;
  width: 100%;
`;

export const SwooshSVG = styled.img`
  position: absolute;
  top: -70px;
  right: 0;
  /* z-index: 1; */
  @media only screen and (min-width: 769px) {
    top: -150px;
  }
`;

export const TitleWrapper = styled.div`
  position: relative;
  width: calc(100% - 20px);
  left: 20px;

  @media only screen and (min-width: 769px) {
    left: 0px;
  }
`;

export const PageTitle = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.091px;
  margin-bottom: 24px;
  color: white;

  @media only screen and (min-width: 769px) {
    margin-top: 32px;
    margin-bottom: 0px;
    font-size: 40px;
    color: white;
  }
`;

export const ContentWrapper = styled.div<{ bgColor?: string }>`
  margin-top: 100px;
  z-index: 2;
  width: 100%;
  min-height: 100px;
  /* @ts-ignore */
  background-color: ${(props) => props?.bgColor ?? "transparent"};
  border-radius: 16px 16px 0 0;
  margin-top: 130px;

  @media only screen and (min-width: 769px) {
    margin-top: 190px;
  }
`;

export const TabsWrapper = styled.div`
  position: relative;
  top: -102px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media only screen and (min-width: 769px) {
    top: -172px;
  }
`;

export const ScheduleCardWrapper = styled.div`
  position: relative;
  top: -92px;
  width: 90%;
  margin-left: 5%;

  @media only screen and (min-width: 769px) {
    top: -158px;
    width: 100%;
    margin: 0;
  }
`;

export const InnerContentWrapper = styled.div`
  width: 100%;

  @media only screen and (min-width: 769px) {
    max-width: 807px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
`;

export const EmptySpace = styled.div<{ height: string }>`
  height: ${({ height }) => height || "40px"};
  background-color: transparent;
`;
